"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    boolToPip: function() {
        return _pip.boolToPip;
    },
    fusionToNormalized: function() {
        return _fusion.fusionToNormalized;
    },
    getPaletteScaleMode: function() {
        return _autoscale.getPaletteScaleMode;
    },
    indexToRotation: function() {
        return _rotation.indexToRotation;
    },
    isAutoScaleOn: function() {
        return _autoscale.isAutoScaleOn;
    },
    normalizedToFusion: function() {
        return _fusion.normalizedToFusion;
    },
    pipToBool: function() {
        return _pip.pipToBool;
    },
    rotationToIndex: function() {
        return _rotation.rotationToIndex;
    }
});
const _pip = require("./pip.js");
const _rotation = require("./rotation.js");
const _fusion = require("./fusion.js");
const _autoscale = require("./autoscale.js");
